export default __webpack_public_path__ + "static/media/Animations_Circle2.d2560f2b.svg";